import { render, staticRenderFns } from "./ImageAlbumCard.vue?vue&type=template&id=061f3909&scoped=true"
import script from "./ImageAlbumCard.vue?vue&type=script&lang=js"
export * from "./ImageAlbumCard.vue?vue&type=script&lang=js"
import style0 from "./ImageAlbumCard.vue?vue&type=style&index=0&id=061f3909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f3909",
  null
  
)

export default component.exports